"use strict";

exports.__esModule = true;
exports.DeviceMapWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _DeviceMapElement = require("./DeviceMapElement");
var _DeviceMapFields = require("./DeviceMapFields");
var _DeviceMapHeader = require("./DeviceMapHeader");
var _DeviceMapThumbnail = require("./DeviceMapThumbnail");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DeviceMapWidget = exports.DeviceMapWidget = {
  name: "DeviceMap",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "DeviceMapWidget.label",
    defaultMessage: "Device Map"
  }),
  icon: "map",
  group: "other",
  createElement: function createElement(props) {
    return {
      type: "DeviceMap",
      props: Object.assign({
        width: 512,
        height: 512
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: false,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment", "color"],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 128,
      min: 32,
      max: 3840
    },
    height: {
      "default": 64,
      min: 32,
      max: 2160
    }
  },
  components: {
    Header: _DeviceMapHeader.DeviceMapHeader,
    Element: _DeviceMapElement.DeviceMapElement,
    Fields: _DeviceMapFields.DeviceMapFields,
    Thumbnail: _DeviceMapThumbnail.DeviceMapThumbnail
  }
};